import ListBulletedNode from './ListBulletedNode'
import ListNumberedNode from './ListNumberedNode'
import ListItemNode from './ListItemNode'
import ListButton from './ListButton'

import EditList from 'slate-edit-list'
const plugin = EditList()

const TYPE = 'List'

const ListSchema = {
  nodes: {
    ul_list: ListBulletedNode,
    ol_list: ListNumberedNode,
    list_item: ListItemNode
  }
}

const onClickButton = (e, state, listType) => {
  e.preventDefault()
  return onApply(state, listType)
}

const onApply = (state, listType) => {
  return state
    .transform()
    .call(plugin.transforms.wrapInList, listType)
    .focus()
    .apply()
}

const ListPlugin = options => {
  return {
    schema: { ...plugin.schema, ...ListSchema },
    onKeyDown: plugin.onKeyDown
  }
}

export {
  TYPE,
  onClickButton,
  ListPlugin,
  ListSchema,
  ListBulletedNode,
  ListNumberedNode,
  ListButton
}



// WEBPACK FOOTER //
// ./src/components/ListSlatePlugin/ListSlatePluginContainer.js